<template>
  <div class="orderList">
    <van-sticky>
      <div
        class="orderListNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">装饰订单</span>
      </div>
    </van-sticky>
    <van-sticky :offset-top="isiOSX ? 88 : 68">
      <div class="orderListTop">
        <van-dropdown-menu>
          <van-dropdown-item :title="activeTitle" disabled />
          <van-dropdown-item title="筛选" ref="orderSatusList">
            <div class="statusOut">
              <span
                v-for="(item, index) of statusList"
                :key="index"
                :class="{ activeSpan: item.check }"
                @click="screen(item.status, index)"
                >{{ item.label }}（{{ item.num }}）</span
              >
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
    </van-sticky>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <template #finished>
          <div class="finishedTip">
            <div v-if="dataList.length == 0">
              <img src="./../../../assets/decoration/noData.png" alt="" />
              <p>暂无相关数据</p>
            </div>
            <div v-else>没有更多了</div>
          </div>
        </template>

        <div class="content">
          <div
            class="item"
            v-for="(item, index) in dataList"
            :key="index"
            @click="toOrderDetails(item.id)"
          >
            <div class="itemTop">
              <div>
                <img src="./../../../assets/decoration/logo.png" alt="" />
                <h3>销巴装饰</h3>
                <img src="./../../../assets/decoration/right.png" alt="" />
              </div>
              <span>{{ item.status_name }}</span>
            </div>
            <div class="itemMid">
              <p>订单编号：{{ item.order_sn }}</p>
              <p>
                下单时间：{{
                  item.is_old_type == 0
                    ? item.created_at
                    : item.first_stage_time
                }}
              </p>
              <p v-if="item.is_old_type == 0">
                装修总价：{{ item.app_status == 8 ? item.total_amount : "-" }}
              </p>
            </div>
            <div
              class="itemBom"
              v-if="item.is_old_type == 0 && item.app_status == 8"
            >
              实付款：
              <span>¥{{ item.pay_amount }}</span>
            </div>
            <div
              class="itemBtm"
              v-if="
                item.app_status == 1 ||
                item.app_status == 3 ||
                item.app_status == 4 ||
                item.app_status == 6 ||
                item.app_status == 10
              "
            >
              <span v-if="item.app_status == 1 || item.app_status == 3" @click.stop="toMoreDetails(item)"
                >去补充</span
              >
              <span v-if="item.app_status == 4 || item.app_status == 10" @click.stop="toMoreDetails(item)"
                >去支付</span
              >
              <span v-if="item.app_status == 6" @click.stop="toMoreDetails(item)">去签署</span>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      refreshing: false,
      dataList: [],
      statusList: [],
      activeStatus: [],
      activeTitle: "",
      activeIndex: 0,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
      sessionStorage.setItem("token", JSON.stringify(this.$route.query.token));
    }
    this.onRefresh("init");
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 订单筛选框列表及数量统计
    getStatusList(type) {
      this.$api.post("decoration/member/order/screen/list").then((res) => {
        this.statusList = res;
        if (type == "init") {
          this.statusList[0].check = true;
          this.activeTitle = `${this.statusList[0].label}（${this.statusList[0].num}）`;
          // 刷新数量
        } else {
          this.statusList[this.activeIndex].check = true;
          this.activeTitle = `${this.statusList[this.activeIndex].label}（${
            this.statusList[this.activeIndex].num
          }）`;
        }
      });
    },
    screen(status, index) {
      this.statusList.forEach((item, i) => {
        item.check = false;
      });
      this.activeStatus = status;
      this.activeIndex = index;
      this.statusList[index].check = true;
      this.statusList = [...this.statusList];
      this.activeTitle = `${this.statusList[index].label}（${this.statusList[index].num}）`;
      this.$refs.orderSatusList.toggle();
      // 筛选数据
      this.page = 1;
      this.dataList = [];
      this.getData();
    },
    // 获取订单列表
    getData() {
      this.loading = true;
      this.$api
        .post("decoration/member/order/list", {
          pageSize: this.pageSize,
          page: this.page,
          status: this.activeStatus,
        })
        .then((res) => {
          // this.dataList = res.list;
          this.dataList = this.dataList.concat(res.list);
          this.loaded = true;
          this.refreshing = false;
          this.loading = false;
          if (this.dataList.length >= res.total) {
            // 数据全部加载完成
            this.finished = true;
          } else {
            this.finished = false;
          }
        })
        .catch((err) => {
          this.refreshing = false;
          this.loading = false;
          this.finished = true;
        });
    },
    // 下拉刷新
    onRefresh(type) {
      this.page = 1;
      this.dataList = [];
      this.getData();
      this.getStatusList(type);
    },
    // 上拉加载
    onLoad() {
      this.page++;
      this.getData();
    },
    // 订单详情
    toOrderDetails(id) {
      this.$router.push({
        path: "/decoration/order/orderDetails",
        query: {
          id: id,
        },
      });
    },
    // 跳转完善信息
    toMoreDetails(item){
      this.$router.push({
        path: "/decoration/order/moreDetails",
        query: {
          id: item.id,
          allComplete: false,
          order_sn: item.order_sn,
          order_status: item.app_status,
        },
      });
    }
  },
};
</script>
<style lang="less">
.orderList {
  min-height: 100%;
  background: #f5f6ff;
  .orderListNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .orderListTop {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // margin: 18px 24px 6px;
    .van-dropdown-menu__bar {
      padding: 0 22px;
      background-color: #f5f6ff;
      box-shadow: none;
    }
    .van-dropdown-menu__item--disabled {
      .van-dropdown-menu__title {
        color: #333333;
        font-size: 15px;
        font-weight: bold;
      }
      .van-dropdown-menu__title::after {
        display: none;
      }
    }
    .van-dropdown-menu__item:last-child {
      .van-dropdown-menu__title {
        height: 26px;
        line-height: 26px;
        padding: 0px 32px 0px 16px;
        background: #ffffff;
        border-radius: 13px;
        font-size: 13px;
        font-weight: 400;
        color: #999999;
      }
    }
    .van-dropdown-menu__title::after {
      right: 16px;
    }
    .van-dropdown-menu__item:first-child {
      justify-content: flex-start;
    }
    .van-dropdown-menu__item:last-child {
      justify-content: flex-end;
    }
    .statusOut {
      margin-top: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      span {
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        margin-bottom: 20px;
        font-weight: normal;
      }
      .activeSpan {
        color: #5853e9;
        font-weight: bold;
      }
    }
  }
  .content {
    margin: 0 16px;
    .item {
      background-color: #ffffff;
      border-radius: 12px;
      margin-bottom: 12px;
      display: flex;
      flex-direction: column;
      padding: 15px 16px 18px;
      .itemTop {
        display: flex;
        justify-content: space-between;
        align-items: center;
        div {
          display: flex;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
          }
          img:last-child {
            width: 12px;
            height: 12px;
          }
          h3 {
            font-size: 15px;
            color: #333333;
            margin: 0 2px;
          }
        }
        span {
          font-size: 14px;
          color: #999999;
        }
      }
      .itemMid {
        display: flex;
        flex-direction: column;
        margin-top: 17px;
        p {
          font-size: 14px;
          color: #999999;
          line-height: 24px;
          margin: 0;
        }
      }
      .itemBom {
        font-size: 15px;
        color: #666666;
        margin-top: 12px;
        display: flex;
        justify-content: flex-end;
        span {
          font-size: 17px;
          color: #333333;
          font-weight: 700;
        }
      }
      .itemBtm {
        font-size: 15px;
        color: #333333;
        margin-top: 12px;
        display: flex;
        justify-content: flex-end;
        span {
          padding: 7px 22px;
          border-radius: 25px;
          border: 1px solid #cacde0;
        }
      }
    }
  }
}
.finishedTip {
  img {
    width: 149px;
    height: 125px;
    margin-top: 64px;
  }
}
</style>